import { wait } from './wait'

export type RetryWhenType = (error: any) => boolean
export type CreateRetryPromiseConfigType = {
  /**
   * @default 3
   */
  maxTries?: number
  /** time in ms to wait for the next retry
   * @default 0
   */
  waitTime?: number
}

/**
 *  Retries to fetch a promise when a condition is met and the ammount of tries aren't exceded
 * @example
 *  const retry = createRetryPromise((error) => error?.response?.status === 400, { maxTries: 5, waitTime: 500 })
 * return retry(() => getSomething())
 */
export function createRetryPromise(
  retryWhen: RetryWhenType,
  { maxTries = 3, waitTime = 0 }: CreateRetryPromiseConfigType = {}
) {
  let retries = 0
  return function retryPromise(executePromise: () => Promise<any>): Promise<any> {
    return executePromise().catch(error => {
      retries++

      if (retries >= maxTries || !retryWhen(error)) {
        return Promise.reject(error)
      }

      if (waitTime === 0) {
        return retryPromise(executePromise)
      }

      return wait(waitTime).then(() => retryPromise(executePromise))
    })
  }
}
